import React, { useEffect, useState } from "react";
import { getAnalytics, TopSop, SopAnalytics } from "../services/api";

export function AnalyticsPage() {
  const [topSops, setTopSops] = useState<TopSop[]>([]);
  const [selectedSop, setSelectedSop] = useState<string>("");
  const [sopDetail, setSopDetail] = useState<SopAnalytics | null>(null);
  const [stationId, setStationId] = useState("");
  const [stationAdoption, setStationAdoption] = useState<{ adopted_sops: string[]; count: number } | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getAnalytics("top_sops").then((d) => { setTopSops(d.top_sops); setLoading(false); });
  }, []);

  const loadSopDetail = async (sopId: string) => {
    setSelectedSop(sopId);
    const data = await getAnalytics("sop_detail", { sop_id: sopId });
    setSopDetail(data);
  };

  const loadStationAdoption = async () => {
    if (!stationId) return;
    const data = await getAnalytics("station_adoption", { station_id: stationId });
    setStationAdoption(data);
  };

  return (
    <div style={{ maxWidth: 800, margin: "0 auto", padding: 24 }}>
      <h2>Analytics</h2>

      {/* Top SOPs */}
      <section style={{ marginBottom: 32 }}>
        <h3>🏆 Most Adopted SOPs</h3>
        {loading ? <p>Loading...</p> : topSops.length === 0 ? (
          <p style={{ color: "#999" }}>No adopted SOPs yet.</p>
        ) : (
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ borderBottom: "2px solid #ddd", textAlign: "left" }}>
                <th style={{ padding: 8 }}>#</th>
                <th style={{ padding: 8 }}>SOP</th>
                <th style={{ padding: 8 }}>Process</th>
                <th style={{ padding: 8 }}>Source Station</th>
                <th style={{ padding: 8 }}>Adoptions</th>
              </tr>
            </thead>
            <tbody>
              {topSops.map((s, i) => (
                <tr key={s.sop_id} style={{ borderBottom: "1px solid #eee", cursor: "pointer" }}
                  onClick={() => loadSopDetail(s.sop_id)}>
                  <td style={{ padding: 8 }}>{i + 1}</td>
                  <td style={{ padding: 8, color: "#1976d2" }}>{s.title || s.sop_id}</td>
                  <td style={{ padding: 8 }}>{s.process_area}</td>
                  <td style={{ padding: 8 }}>{s.station_id}</td>
                  <td style={{ padding: 8, fontWeight: "bold" }}>{s.adoption_count ?? 0}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </section>

      {/* SOP Detail */}
      {sopDetail && (
        <section style={{ marginBottom: 32, padding: 16, background: "#f5f5f5", borderRadius: 8 }}>
          <h3>📊 Detail: {selectedSop}</h3>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 12, marginBottom: 16 }}>
            <Stat label="Total Views" value={sopDetail.views_total} />
            <Stat label="Views (7d)" value={sopDetail.views_last_7d} />
            <Stat label="Adoptions" value={sopDetail.adoptions} />
            <Stat label="Shares" value={sopDetail.shares} />
          </div>
          {sopDetail.adopting_stations.length > 0 && (
            <div>
              <strong>Adopted by:</strong>{" "}
              {sopDetail.adopting_stations.map((s) => (
                <span key={s} style={{ display: "inline-block", background: "#e3f2fd", padding: "2px 10px", borderRadius: 12, margin: "2px 4px", fontSize: 13 }}>
                  {s}
                </span>
              ))}
            </div>
          )}
        </section>
      )}

      {/* Station Adoption */}
      <section>
        <h3>🏭 Station Adoption Lookup</h3>
        <div style={{ display: "flex", gap: 8, marginBottom: 16 }}>
          <input value={stationId} onChange={(e) => setStationId(e.target.value)}
            placeholder="Station ID (e.g. DSD4)" style={{ flex: 1, padding: 8 }} />
          <button onClick={loadStationAdoption} style={{ padding: "8px 16px" }}>Lookup</button>
        </div>
        {stationAdoption && (
          <div>
            <p>Station <strong>{stationId}</strong> has adopted <strong>{stationAdoption.count}</strong> SOP{stationAdoption.count !== 1 ? "s" : ""}:</p>
            {stationAdoption.adopted_sops.length > 0 ? (
              <ul>{stationAdoption.adopted_sops.map((id) => <li key={id}>{id}</li>)}</ul>
            ) : (
              <p style={{ color: "#999" }}>No adoptions recorded.</p>
            )}
          </div>
        )}
      </section>
    </div>
  );
}

function Stat({ label, value }: { label: string; value: number }) {
  return (
    <div style={{ textAlign: "center", padding: 12, background: "#fff", borderRadius: 8 }}>
      <div style={{ fontSize: 28, fontWeight: "bold", color: "#1976d2" }}>{value}</div>
      <div style={{ fontSize: 12, color: "#666" }}>{label}</div>
    </div>
  );
}
